/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Contact
 */
export interface Contact {
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  phoneNumber?: string;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  phoneNumberExtension?: string;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  emailAddress?: string;
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  contactName?: string;
}

/**
 * Check if a given object implements the Contact interface.
 */
export function instanceOfContact(value: object): value is Contact {
  return true;
}

export function ContactFromJSON(json: any): Contact {
  return ContactFromJSONTyped(json, false);
}

export function ContactFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Contact {
  if (json == null) {
    return json;
  }
  return {
    phoneNumber: json["phoneNumber"] == null ? undefined : json["phoneNumber"],
    phoneNumberExtension:
      json["phoneNumberExtension"] == null
        ? undefined
        : json["phoneNumberExtension"],
    emailAddress:
      json["emailAddress"] == null ? undefined : json["emailAddress"],
    contactName: json["contactName"] == null ? undefined : json["contactName"],
  };
}

export function ContactToJSON(json: any): Contact {
  return ContactToJSONTyped(json, false);
}

export function ContactToJSONTyped(
  value?: Contact | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    phoneNumber: value["phoneNumber"],
    phoneNumberExtension: value["phoneNumberExtension"],
    emailAddress: value["emailAddress"],
    contactName: value["contactName"],
  };
}
